import { useState, useRef } from 'react';
import '../pages/ClaimCard.css';
import { useAppContext } from '../AppContext';
import { Link } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { useDevHub } from '../context/devhub/useDevHubSDK.js';

const NUM_CHARS = 4;

const CodeInput = ({ length, onComplete, onSubmit, errorMessage }) => {
  const { setPasteCodeResult } = useAppContext();

  const [values, setValues] = useState(new Array(NUM_CHARS).fill(''));
  const inputRefs = useRef([]);

  const [codeEntered, setCodeEntered] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { devHubUser } = useDevHub();

  const handleChange = (val, index) => {
    if (!/^[a-zA-Z0-9]*$/.test(val)) return; // allow only alphanumeric characters
    const newValues = [...values];
    newValues[index] = val;
    setValues(newValues);

    // automatically move to next input if valid input is detected
    if (val && index < length - 1) {
      const nextInput = document.getElementById(`code-input-${index + 1}`);
      nextInput?.focus();
    }

    // trigger the onComplete callback when all inputs are filled
    if (newValues.every((char) => char !== '')) {
      onComplete(newValues.join(''));
      setCodeEntered(true);
      // onSubmit(newValues.join(''));
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text');
    setPasteCodeResult(pastedData);

    // Split pasted data into individual characters and populate the inputs
    if (pastedData.length === NUM_CHARS) {
      const newValues = pastedData.split('').slice(0, NUM_CHARS);
      setValues(newValues);
      console.log(newValues);
      console.log(values);

      // Move focus to the last field
      inputRefs.current[5]?.focus();

      // trigger the onComplete callback when all inputs are filled
      if (newValues.every((char) => char !== '')) {
        onComplete(newValues.join(''));
        setCodeEntered(true);
        // onSubmit(newValues.join(''));
      }
    }
  };

  const handleSubmit = async () => {
    const newValues = [...values];
    setIsLoading(true);
    await onSubmit(newValues.join(''));
    setIsLoading(false);
    console.log('new values', newValues);
  };

  return (
    <div>
      <div style={{
        display: 'flex', justifyContent: 'center', gap: '10px', marginTop: 20
      }}>
        {values.map((val, index) => (
          <input
            key={index}
            id={`code-input-${index}`}
            type="text"
            maxLength={1}
            value={val}
            onPaste={handlePaste}
            onChange={(e) => handleChange(e.target.value.toUpperCase(), index)}
            style={{
              width: '40px',
              fontSize: '20px',
              textAlign: 'center',
              color: '#fff',
              border: '1px solid #f7d58e',
              backgroundColor: '#262541',
              fontWeight: 800
            }}
          />
        ))}
      </div>
      <div>
        {errorMessage && <p style={{ color: 'white', textAlign: 'center' }}>{errorMessage} </p>}
        <p style={{
          color: '#cecece',
          fontWeight: 300,
          fontSize: '11px',
          textAlign: 'center',
          display: 'block',
          margin: '0 auto',
          // maxWidth: '300px',
          // lineBreak: 'anywhere',
          marginTop: 40
        }}>
          By clicking "claim" you are creating a public digital wallet that can be used to access your digital collectible on the Aptos blockchain network (view the <a href="https://aptoslabs.com/privacy" style={{color: '#ffffff'}} target="_blank">Aptos Privacy Policy</a>).<br/><br/>Once your information is on the blockchain as a result of collecting your medallions, it will be publicly accessible. NBCUniversal will not have the ability to control or monitor its use. More information can be found on our <Link to='/how-to-train-your-dragon/' state= {{ scrollToTarget: true }} style={{ color: '#ffffff' }}>Frequently Asked Questions</Link> page.
        </p>
        <button
          className='claim-button'
          disabled={isLoading || length < NUM_CHARS || !codeEntered || !devHubUser?.address}
          style={{
            opacity: length >= NUM_CHARS ? 1 : 0.2,
            cursor: length >= NUM_CHARS ? 'pointer' : 'not-allowed',
            width: '100%',
            marginTop: 30
          }}
          onClick={handleSubmit}
        >
          {(isLoading || !devHubUser?.address)
            ? <CircularProgress size={25} style={{ margin: '0 auto', display: 'block', color: '#00000' }} sx={{ color: '#000000' }} />
            : "Claim"}
        </button>
        {!devHubUser?.address &&
          <p style={{ color: "#ffffff", textAlign: 'center', fontSize: 13 }}>
            Just a moment while we get everything ready.
          </p>}
        {/* <button
          className='claim-button'
          disabled={isLoading}
          style={{
            opacity: length >= NUM_CHARS ? 1 : 0.2,
            cursor: length >= NUM_CHARS ? 'pointer' : 'not-allowed',
            width: '100%',
            marginTop: 30
          }}
          onClick={handleSubmit}
        >
          {isLoading
            ? <CircularProgress size={25} style={{ margin: '0 auto', display: 'block', color: '#00000' }} sx={{ color: '#000000' }} />
            : "Claim"}
        </button> */}
      </div>
    </div>
  );
};

export default CodeInput;